import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Carrier from "./Carrier";
import AirportDeparture from "./AirportDeparture ";
import AirportDestination from "./AirportDestination ";
import TimeDeparture from "./TimeDeparture";
import TimeArrival from "./TimeArrival";
import { classList } from "@utils";

const FlightLegs = ({
  index,
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  // valueState,
  // suggestions,
  // setSuggestions,
  // isSelectSuggestion,
  // changeInput,
  // airlineDetails,
  // departureValue,
  // airportDetails,
  // changeDepartureInput,
  // departureSelected,
  // depSuggestions,
  // setDepSuggestions,
  // destinationValue,
  // changeDestinationInput,
  // destinationSelected,
  // desSuggestion,
  // setDesSuggestion,
  timeDeparture,
  changeTimeDepartureInput,
  timeArrival,
  changeTimeArrivalInput,
  tripType,
  arrayHelpers,
  setFieldValue,
}) => {
  return (
    <>
      {index > 0 && <hr />}
      <Row className="my-2">
        <Col xs="6 d-none">
          <Form.Label className="heading2 lead">Leg {index + 1}</Form.Label>
        </Col>
        {index > 0 && (
          <Col xs="6">
            <div className="d-flex justify-content-end ">
              <Button
                className="mt-2"
                variant="danger"
                type="button"
                onClick={() => {
                  arrayHelpers.remove(index);
                }}
              >
                Delete Leg
              </Button>
            </div>
          </Col>
        )}
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group
            className={classList({
              " mb-3": true,
              "valid-field":
                !errors.flightLegs?.onward[index]?.flightNumber &&
                touched.flightLegs?.onward[index]?.flightNumber,
              "invalid-field":
                errors.flightLegs?.onward[index]?.flightNumber &&
                touched.flightLegs?.onward[index]?.flightNumber,
            })}
            controlId="formBasicEmail"
          >
            <Form.Label className="heading">
              Flight Number<span className="text-danger">*</span>
            </Form.Label>
            <input
              className="form-control"
              type="text"
              placeholder=""
              name={`flightLegs.onward[${index}].flightNumber`}
              value={values.flightLegs.onward[index].flightNumber}
              onChange={handleChange}
              error={
                errors.flightLegs &&
                errors.flightLegs.onward &&
                errors.flightLegs.onward[index] &&
                errors.flightLegs.onward[index].flightNumber
              }
              onBlur={handleBlur}
            />
            {touched.flightLegs?.onward[index]?.flightNumber &&
            errors.flightLegs?.onward[index]?.flightNumber ? (
              <div className="error-label">
                {errors.flightLegs?.onward[index]?.flightNumber}{" "}
                {values.flightLegs.onward[index].flightNumber}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Carrier<span className="text-danger">*</span>
            </Form.Label>

            <Carrier
              index={index}
              value={values.flightLegs.onward[index].flightCarrierId}
              onChange={handleChange}
              error={
                errors.flightLegs &&
                errors.flightLegs.onward &&
                errors.flightLegs.onward[index] &&
                errors.flightLegs.onward[index].Carrier
              }
              touched={touched?.flightLegs?.onward[index]?.Carrier}
              onBlur={handleBlur}
              setFieldValue={setFieldValue}
            />

            {touched.flightLegs?.onward[index]?.flightCarrierId &&
            errors.flightLegs?.onward[index]?.flightCarrierId ? (
              <div className="error-label">
                {errors.flightLegs?.onward[index]?.flightCarrierId}{" "}
                {values.flightLegs.onward[index].flightCarrierId}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Airport Departure<span className="text-danger">*</span>
            </Form.Label>

            <AirportDeparture index={index} setFieldValue={setFieldValue} />

            {touched.flightLegs?.onward[index]?.airportDepartureId &&
            errors.flightLegs?.onward[index]?.airportDepartureId ? (
              <div className="error-label">
                {errors.flightLegs?.onward[index]?.airportDepartureId}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Airport Destination<span className="text-danger">*</span>
            </Form.Label>

            <AirportDestination index={index} setFieldValue={setFieldValue} />

            {touched.flightLegs?.onward[index]?.airportDestinationId &&
            errors.flightLegs?.onward[index]?.airportDestinationId ? (
              <div className="error-label">
                {errors.flightLegs?.onward[index]?.airportDestinationId}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Time Departure<span className="text-danger">*</span>
            </Form.Label>
            <TimeDeparture
              index={index}
              timeDeparture={timeDeparture}
              changeTimeDepartureInput={changeTimeDepartureInput}
              setFieldValue={setFieldValue}
            />
            {touched.flightLegs?.onward[index]?.departureTime &&
            errors.flightLegs?.onward[index]?.departureTime ? (
              <div className="error-label">
                {errors.flightLegs?.onward[index]?.departureTime}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Time Arrival<span className="text-danger">*</span>
            </Form.Label>
            <TimeArrival
              index={index}
              timeArrival={timeArrival}
              changeTimeArrivalInput={changeTimeArrivalInput}
              touched={touched}
              setFieldValue={setFieldValue}
            />
            {touched.flightLegs?.onward[index]?.arrivalTime &&
            errors.flightLegs?.onward[index]?.arrivalTime ? (
              <div className="error-label">
                {errors.flightLegs?.onward[index]?.arrivalTime}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Check In Baggage<span className="text-danger">*</span>
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder=""
              name={`flightLegs.onward[${index}].checkInBaggage`}
              value={values.flightLegs.onward[index].checkInBaggage}
              error={
                errors.flightLegs &&
                errors.flightLegs.onward &&
                errors.flightLegs.onward[index] &&
                errors.flightLegs.onward[index].checkInBaggage
              }
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {touched.flightLegs?.onward[index]?.checkInBaggage &&
            errors.flightLegs?.onward[index]?.checkInBaggage ? (
              <div className="error-label">
                {errors.flightLegs?.onward[index]?.checkInBaggage}{" "}
                {values.flightLegs.onward[index].checkInBaggage}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType === 2 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Fare Type<span className="text-danger">*</span>
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder=""
              name={`flightLegs.onward[${index}].fareType`}
              value={values.flightLegs.onward[index].fareType}
              error={
                errors.flightLegs &&
                errors.flightLegs.onward &&
                errors.flightLegs.onward[index] &&
                errors.flightLegs.onward[index].fareType
              }
              onChange={handleChange}
              onBlur={handleBlur}
            />

            {touched.flightLegs?.onward[index]?.fareType &&
            errors.flightLegs?.onward[index]?.fareType ? (
              <div className="error-label">
                {errors.flightLegs?.onward[index]?.fareType}{" "}
                {values.flightLegs.onward[index].fareType}
              </div>
            ) : (
              ""
            )}

            {/* <Form.Control.Feedback type="invalid">
              {touched.flightLegs &&
                touched.flightLegs.onward &&
                touched.flightLegs.onward[index] &&
                errors.flightLegs &&
                errors.flightLegs.onward &&
                errors.flightLegs.onward[index] &&
                touched.flightLegs.onward[index].fareType &&
                errors.flightLegs.onward[index].fareType}
            </Form.Control.Feedback> */}
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default FlightLegs;
